export default function ProductContractTab({ showTab, values }) {
  return (
    <div
      id="tab-top-2"
      className={
        showTab === 'tab3' ? 'card tab-pane active show' : 'card tab-pane'
      }
    >
      <div className="card-body" style={{ minHeight: '200px' }}>
        {values.product_contract_attachments_old &&
        values.product_contract_attachments_old.length > 0 ? (
          <ul className="list-group list-group-flush">
            {values.product_contract_attachments_old.map((attachment) => (
              <li key={attachment.id} className="list-group-item">
                <a
                  href={
                    attachment.path ||
                    attachment.processed_path ||
                    attachment.raw_path
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: 'none',
                    color: '#007bff',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <i
                    className="material-icons"
                    style={{
                      fontSize: '18px',
                      marginRight: '8px',
                    }}
                  >
                    attach_file
                  </i>
                  <span style={{ verticalAlign: 'middle' }}>
                    {attachment.name || attachment.file_name}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">No attachments available</p>
        )}
      </div>
    </div>
  );
}
